<template>
  <svg
    width="178"
    height="161"
    viewBox="0 0 178 161"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.06"
      d="M89.9072 140C123.043 140 149.907 113.189 149.907 80C149.907 46.811 122.925 20 89.9072 20C56.7711 20 29.9072 46.811 29.9072 80C29.9072 113.189 56.7711 140 89.9072 140Z"
      fill="url(#paint0_linear_10073_64918)"
    />
    <g opacity="0.9">
      <g filter="url(#filter0_d_10073_64918)">
        <rect
          x="58.0791"
          y="101.946"
          width="54.8819"
          height="25.6591"
          rx="4"
          transform="rotate(-4 58.0791 101.946)"
          fill="url(#paint1_linear_10073_64918)"
        />
      </g>
      <rect
        opacity="0.24"
        x="66.8599"
        y="104.904"
        width="17.106"
        height="4.27651"
        rx="2.13826"
        transform="rotate(-4 66.8599 104.904)"
        fill="url(#paint2_linear_10073_64918)"
      />
      <path
        opacity="0.2"
        d="M67.7549 117.702L104.017 115.167"
        stroke="url(#paint3_linear_10073_64918)"
        stroke-width="1.63636"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        opacity="0.2"
        d="M67.4565 113.436L103.718 110.901"
        stroke="url(#paint4_linear_10073_64918)"
        stroke-width="1.63636"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        opacity="0.2"
        d="M68.0532 121.968L88.6727 120.526"
        stroke="url(#paint5_linear_10073_64918)"
        stroke-width="1.63636"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <rect
        opacity="0.04"
        x="61.1914"
        y="126.021"
        width="22.8081"
        height="4.27651"
        rx="2.13826"
        transform="rotate(-94 61.1914 126.021)"
        fill="url(#paint6_linear_10073_64918)"
      />
    </g>
    <g filter="url(#filter1_d_10073_64918)">
      <rect
        x="22"
        y="64.8262"
        width="77"
        height="36"
        rx="4"
        transform="rotate(-7 22 64.8262)"
        fill="url(#paint7_linear_10073_64918)"
      />
    </g>
    <rect
      opacity="0.24"
      x="34.52"
      y="68.3264"
      width="24"
      height="6"
      rx="3"
      transform="rotate(-7 34.52 68.3264)"
      fill="url(#paint8_linear_10073_64918)"
    />
    <path
      opacity="0.2"
      d="M36.7134 86.1924L87.3332 79.977"
      stroke="url(#paint9_linear_10073_64918)"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      opacity="0.2"
      d="M35.9824 80.2371L86.6023 74.0217"
      stroke="url(#paint10_linear_10073_64918)"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      opacity="0.2"
      d="M37.4448 92.1475L66.2287 88.6132"
      stroke="url(#paint11_linear_10073_64918)"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <rect
      opacity="0.04"
      x="28.1284"
      y="98.3291"
      width="32"
      height="6"
      rx="3"
      transform="rotate(-97 28.1284 98.3291)"
      fill="url(#paint12_linear_10073_64918)"
    />
    <g filter="url(#filter2_d_10073_64918)">
      <rect
        x="93.5986"
        y="75.2534"
        width="63"
        height="29.4545"
        rx="4"
        transform="rotate(9 93.5986 75.2534)"
        fill="url(#paint13_linear_10073_64918)"
      />
    </g>
    <rect
      x="147.296"
      y="87.8081"
      width="4"
      height="5"
      rx="2"
      transform="rotate(9 147.296 87.8081)"
      fill="url(#paint14_linear_10073_64918)"
    />
    <rect
      opacity="0.5"
      x="142.357"
      y="87.0259"
      width="4"
      height="5"
      rx="2"
      transform="rotate(9 142.357 87.0259)"
      fill="url(#paint15_linear_10073_64918)"
    />
    <rect
      opacity="0.24"
      x="102.656"
      y="80.8298"
      width="19.6364"
      height="4.90909"
      rx="2.45455"
      transform="rotate(9 102.656 80.8298)"
      fill="url(#paint16_linear_10073_64918)"
    />
    <path
      opacity="0.2"
      d="M100.352 95.3757L141.566 101.903"
      stroke="url(#paint17_linear_10073_64918)"
      stroke-width="1.6"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      opacity="0.2"
      d="M101.12 90.5271L142.334 97.0547"
      stroke="url(#paint18_linear_10073_64918)"
      stroke-width="1.6"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      opacity="0.2"
      d="M99.584 100.224L123.019 103.936"
      stroke="url(#paint19_linear_10073_64918)"
      stroke-width="1.6"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <rect
      opacity="0.04"
      x="90.8633"
      y="102.985"
      width="26.1818"
      height="4.90909"
      rx="2.45455"
      transform="rotate(-81 90.8633 102.985)"
      fill="url(#paint20_linear_10073_64918)"
    />
    <g filter="url(#filter3_d_10073_64918)">
      <rect
        x="58.2563"
        y="31.3582"
        width="77"
        height="36"
        rx="4"
        transform="rotate(4 58.2563 31.3582)"
        fill="url(#paint21_linear_10073_64918)"
      />
    </g>
    <rect
      opacity="0.24"
      x="69.8784"
      y="37.1831"
      width="24"
      height="6"
      rx="3"
      transform="rotate(4 69.8784 37.1831)"
      fill="url(#paint22_linear_10073_64918)"
    />
    <rect
      x="125.742"
      y="41.0894"
      width="5"
      height="6"
      rx="2.5"
      transform="rotate(4 125.742 41.0894)"
      fill="url(#paint23_linear_10073_64918)"
    />
    <rect
      opacity="0.5"
      x="119.756"
      y="40.6709"
      width="5"
      height="6"
      rx="2.5"
      transform="rotate(4 119.756 40.6709)"
      fill="url(#paint24_linear_10073_64918)"
    />
    <path
      opacity="0.2"
      d="M68.6226 55.1392L119.498 58.6967"
      stroke="url(#paint25_linear_10073_64918)"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      opacity="0.2"
      d="M69.041 49.1538L119.917 52.7114"
      stroke="url(#paint26_linear_10073_64918)"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      opacity="0.2"
      d="M68.2041 61.1245L97.1335 63.1474"
      stroke="url(#paint27_linear_10073_64918)"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <rect
      opacity="0.04"
      x="57.8799"
      y="65.4148"
      width="32"
      height="6"
      rx="3"
      transform="rotate(-86 57.8799 65.4148)"
      fill="url(#paint28_linear_10073_64918)"
    />
    <defs>
      <filter
        id="filter0_d_10073_64918"
        x="36.3481"
        y="87.3862"
        width="100"
        height="72.8867"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10073_64918"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10073_64918"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_10073_64918"
        x="0.457031"
        y="44.8994"
        width="123.899"
        height="88.2012"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10073_64918"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10073_64918"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_10073_64918"
        x="67.5669"
        y="64.8293"
        width="109.68"
        height="81.7954"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10073_64918"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10073_64918"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_10073_64918"
        x="34.0142"
        y="20.6272"
        width="122.786"
        height="84.7454"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10073_64918"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10073_64918"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10073_64918"
        x1="29.9054"
        y1="139.999"
        x2="149.906"
        y2="19.9985"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10073_64918"
        x1="85.5022"
        y1="101.352"
        x2="85.5022"
        y2="127.881"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_10073_64918"
        x1="66.8596"
        y1="109.18"
        x2="68.8721"
        y2="101.13"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_10073_64918"
        x1="67.8241"
        y1="118.7"
        x2="67.7395"
        y2="116.703"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_10073_64918"
        x1="67.5257"
        y1="114.434"
        x2="67.4412"
        y2="112.436"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_10073_64918"
        x1="68.1227"
        y1="122.966"
        x2="68.0798"
        y2="120.969"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_10073_64918"
        x1="61.1911"
        y1="130.297"
        x2="62.7403"
        y2="122.035"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_10073_64918"
        x1="60.4749"
        y1="63.9935"
        x2="60.4749"
        y2="101.214"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_10073_64918"
        x1="34.5196"
        y1="74.3264"
        x2="37.3432"
        y2="63.0322"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_10073_64918"
        x1="36.8345"
        y1="87.185"
        x2="36.6297"
        y2="85.1959"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_10073_64918"
        x1="36.1035"
        y1="81.2297"
        x2="35.8988"
        y2="79.2406"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_10073_64918"
        x1="37.5662"
        y1="93.1401"
        x2="37.3912"
        y2="91.1489"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_10073_64918"
        x1="28.1279"
        y1="104.329"
        x2="30.3015"
        y2="92.7366"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_10073_64918"
        x1="125.078"
        y1="74.5721"
        x2="125.078"
        y2="105.026"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_10073_64918"
        x1="147.296"
        y1="92.8081"
        x2="152.174"
        y2="88.9056"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_10073_64918"
        x1="142.357"
        y1="92.0258"
        x2="147.235"
        y2="88.1234"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_10073_64918"
        x1="102.655"
        y1="85.7389"
        x2="104.966"
        y2="76.4982"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_10073_64918"
        x1="100.195"
        y1="96.3633"
        x2="100.555"
        y2="94.3966"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_10073_64918"
        x1="100.963"
        y1="91.5147"
        x2="101.323"
        y2="89.5479"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_10073_64918"
        x1="99.4272"
        y1="101.212"
        x2="99.8226"
        y2="99.2533"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_10073_64918"
        x1="90.8629"
        y1="107.894"
        x2="92.6413"
        y2="98.4094"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_10073_64918"
        x1="96.7313"
        y1="30.5254"
        x2="96.7313"
        y2="67.7463"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_10073_64918"
        x1="69.878"
        y1="43.1831"
        x2="72.7016"
        y2="31.8889"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_10073_64918"
        x1="125.742"
        y1="47.0893"
        x2="131.643"
        y2="42.1713"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_10073_64918"
        x1="119.756"
        y1="46.6709"
        x2="125.658"
        y2="41.7528"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_10073_64918"
        x1="68.552"
        y1="56.1367"
        x2="68.7306"
        y2="54.145"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_10073_64918"
        x1="68.9705"
        y1="50.1513"
        x2="69.149"
        y2="48.1597"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_10073_64918"
        x1="68.1339"
        y1="62.122"
        x2="68.342"
        y2="60.1341"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_10073_64918"
        x1="57.8794"
        y1="71.4148"
        x2="60.053"
        y2="59.8223"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
